import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';

export interface TabOption {
  value: string;
  label: string;
  ariaLabel?: string;
}

export type LoginRegisterValue = 'login' | 'register' | 'forgotPassword';

@Component({
    selector: 'app-login-register-tabs',
    imports: [],
    templateUrl: './login-register-tabs.component.html',
    styleUrl: './login-register-tabs.component.scss'
})
export class LoginRegisterTabsComponent {
  @Input() value: LoginRegisterValue = 'login';
  @Input() options: TabOption[] = [
    { value: 'login', label: 'Login', ariaLabel: 'Login tab' },
    { value: 'register', label: 'Sign Up', ariaLabel: 'Register tab' }
  ];
  @Output() valueChange = new EventEmitter<LoginRegisterValue>();

  select(value: string) {
    if (this.value !== value) {
      this.value = value as LoginRegisterValue;
      this.valueChange.emit(this.value);
    }
  }

  selectLoginRegister(value: LoginRegisterValue) {
    this.select(value);
  }
} 
